module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-features"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('h2', [_vm._v("Hvala za reševanje ankete s pomočjo aplikacije eQuiz!")]), _vm._v(" "), _c('h3', [_vm._v("Kaj je eQuiz?")]), _vm._v(" "), _c('p', [_vm._v("Je spletna in mobilna aplikacija v razvoju na Fakulteti za računalništvo in informatiko v Ljubljani.")]), _vm._v(" "), _c('p', [_vm._v("Ustvarjena je za prenos znanja iz miz, zasutih s knjigami in zvezki, v izzive dostopne kjerkoli in kadarkoli.")]), _vm._v(" "), _c('h3', [_vm._v("Komu je namenjen?")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("Kontakt")]), _vm._v(" "), _c('p', [_vm._v("Equiz je še v izdelavi. Za prejemanje najnovejših informacij o aplikaciji prosim vpišite svoj email.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control skin-blue",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.subscribe()
      }
    }
  }, [_vm._v("Naroči se!")])])])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', [_c('img', {
    staticClass: "logo-test",
    attrs: {
      "src": require("../../assets/logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Namenjena je vsem "), _c('span', {
    staticClass: "text-light-blue"
  }, [_vm._v("pedagogom")]), _vm._v(", ki želijo svojim "), _c('span', {
    staticClass: "text-green"
  }, [_vm._v("učencem")]), _vm._v(" ali  \n          "), _c('span', {
    staticClass: "text-green"
  }, [_vm._v("dijakom")]), _vm._v(" omogočiti nove in interaktivne oblike izobraževanja in sprotnega dela.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-success feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Enostavno reševanje nalog\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Učenec oziroma dijak enostavno in hitro rešuje naloge, s možnostjo uporabe namigov in rešitev ob nastopu težav, tako na mobilnem telefonu kot v spletnem brskalniku.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-success feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Vodeno nadgrajevanje znanja\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Postopno nadgrajuje in utrjuje znanje z zaporedjem kvizov in izzivov. Omogočen lahek pregled nad že osvojenim znanjem in hiter dostop do novih izzivov.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-success feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Spremljanje in vzpodbujanje napredka\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Ima podroben vpogled v lastno zgodovino reševanja. Aplikacija vzpodbuja in usmerja uporabo s izkušenjskimi točkami, nivoji in tekmovanjem s prijatelji.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Upravljanje knjižnice nalog\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Kot skrbnik skupine lahko enostavno uvažate naloge različnih formatov. Možno njihovo urejanje in dodajanje novih v temu namenjenemu urejevalniku. \n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Ustvarjanje drevesa nalog\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Hitro delite naloge in kvize po skupinah in poljubno številnih podskupinah. Prilagajate svoj drevo nalog čim hitrejšemu postopnemu napredovanju učencev oziroma dijakov.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Uspešnost kvizov in izpitov\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Enostaven vpogled v statistiko reševanja kviza uporabnikov. Vsebuje pregled nad povprečno uspešnostjo posameznih nalog in neposredno do mnenj reševalcev.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Sledenje uspešnosti letnika\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Podroben pregled statistične uspešnosti tekočega letnika. Aktivnost uporabnikov, njihov skupni napredek in uspeh v primerjavi z minulimi letniki.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Komunikacija z uporabniki\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Enostavno komuniciranje in lahko prilagajanje željam uporabnikom s sistemom ocenjevanja nalog in kvizov, ter poročanjem napak.\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "box box-primary feature"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('dt', [_vm._v("\n          Avtomatizirano ustvarjanje izpitov\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('dd', [_vm._v("\n          Aplikacija vsebuje sistem statistično podprtega pridobivanja znanja o učencih oziroma dijakih in nalogah, ki avtomatizira proces ustvarjanja kvizov in izpitov s primerno težavnostjo, časovnim vložkom in zahtevanim znanjem.\n        ")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58227b76", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58227b76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Features.vue
// module id = 1402
// module chunks = 1